// extracted by mini-css-extract-plugin
export default {"alerttitleBox":"index_alerttitleBox_yzcUS","alerttitle":"index_alerttitle_t3I7W","alertcontent":"index_alertcontent_NiEKo"};